import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import React, { useState } from "react";
import { OrderDialog } from "../trading/OrderDialog";
import { InvestmentGoalsDialog } from "../trading/InvestmentGoalsDialog";
import { useToast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { createNavItems } from "@/constants/navigation";

interface SidebarProps {
  className?: string;
}

export const Sidebar = ({ className }: SidebarProps) => {
  const [showOrderDialog, setShowOrderDialog] = useState(false);
  const [showGoalsDialog, setShowGoalsDialog] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleOrderSubmit = (data: {
    name?: string;
    symbol?: string;
    direction?: string;
    engine?: string;
    duration?: string;
  }) => {
    // Generate a strategy name if none provided, with safe handling of undefined values
    const strategyName = data.name || 
      `${(data.direction || 'BUY').toUpperCase()} ${data.symbol || 'UNKNOWN'} ${data.duration || 'DAY'}`;
    
    // Here you would typically handle the order submission
    // For now, we'll just show a toast notification
    toast({
      title: "Order Placed",
      description: `${strategyName} strategy has been created.`,
    });
    
    setShowOrderDialog(false);
  };

  const navItems = createNavItems(navigate, setShowOrderDialog);

  return (
    <div
      className={cn(
        "group/sidebar h-screen relative bg-white/10 backdrop-blur-lg border-r border-r-white/10 shadow-lg transition-all duration-300 ease-in-out w-[70px]",
        className
      )}
    >

      <div className="flex flex-col gap-2 p-4">
        {navItems.map((item, index) => (
          <div key={index} className="space-y-1">
            <Button
              variant="ghost"
              onClick={item.onClick}
              className="group flex items-center p-2 w-12 bg-white/90 hover:bg-white/95 text-gray-700 hover:text-primary border border-transparent hover:border-white/20 shadow-sm backdrop-blur-sm transition-all duration-200 hover:w-48 overflow-hidden"
            >
              <item.icon className="h-5 w-5 flex-shrink-0" />
              <span className="ml-2 text-sm font-medium overflow-hidden whitespace-nowrap transition-all duration-200 max-w-0 opacity-0 group-hover:max-w-[10rem] group-hover:opacity-100">
                {item.title}
              </span>
            </Button>
          </div>
        ))}
      </div>

      <OrderDialog
        open={showOrderDialog}
        onOpenChange={setShowOrderDialog}
        onSubmit={handleOrderSubmit}
      />

      <InvestmentGoalsDialog
        open={showGoalsDialog}
        onOpenChange={setShowGoalsDialog}
      />
    </div>
  );
};
